import * as React from "react";
import styles from "./Dashboard.module.scss";

const Dashboard = (): JSX.Element => {
  return (
    <div>
      <h1 className={styles.dashboard}>DASHBOARD</h1>
      <h2>This section is under development 🙂</h2>
    </div>
  );
};

export default Dashboard;
